import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  version: 0,
};

const watchlistSlice = createSlice({
  name: "watchlist",
  initialState,
  reducers: {
    refreshWatchlist(state) {
      state.version += 1;
    },
  },
});

export const { refreshWatchlist } = watchlistSlice.actions;

export default watchlistSlice.reducer;
